import { render } from "./Header.vue?vue&type=template&id=c65a3fe8&scoped=true"
const script = {}

import "./Header.vue?vue&type=style&index=0&id=c65a3fe8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c65a3fe8"]])

export default __exports__